import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CwcInputDateRange } from '@cmx-web-components/core/'
// interfaces
import { FinancialDocument } from './../../cemexcomponents/types/v2/financialDocuments.dto';
import { Dispute } from './../../cemexcomponents/types/v2/disputeManagement.dto';
import { CreditRequest } from '../credit-request/models/credit-request.model';
import { UserInfo } from '../../cemexcomponents/types/v2/index';
import { DocumentReference } from './../../cemexcomponents/types/v2/';
import { IExternalAppData } from "../core/models/externalAppData.model";
import { StorageManagerService } from "@app/core/services/storage-manager.service";
import { CmxAuthProfile } from "@cemex-core/angular-services-v8";



@Injectable()
export class SharedDataService {
  private _checkedFinancialDocuments: FinancialDocument[] = [];
  private checkedFinancialDocumentsKey: string = "invpay_financialDocuments";

  private _financialDocument: FinancialDocument;
  private financialDocumentKey: string = "invpay_financialDocument";

  private _dispute: Dispute;
  private disputeKey: string = "invpay_dispute";

  private _creditRequest: CreditRequest;
  private creditRequestKey: string = "invpay_request";

  private _dateRange: CwcInputDateRange;
  private dateRangeKey: string = "invpay_dateRange";

  private _userInfo: UserInfo;
  private _userProfile: CmxAuthProfile;
  private _checkedDocumentReferences: DocumentReference[] = [];
  private checkedDocumentReferencesKey: string = "invpay_documentReferences";

  private _documentReferences: DocumentReference;
  private documentReferencesKey: string = "invpay_documentReference";

  public _formDataDocumentReferences: any;
  public _bulkExcelDocCenter: boolean;
  private bulkExcelDocCenterKey: string = "bulkExcelDocCenter";

  public data1: string = "";

  private _clarificationsCategory = "";
  private clarificationsCategoryKey = "clarification_category";

  public goodReceiptReferencesKey: string = "invpay_goodReceiptReference";

  private _checkedGoodReceiptDocuments: any[] = [];
  private checkedGoodReceiptDocumentsKey: string =
    "invpay_goodReceiptDocuments";

  private _goodReceiptHasRows = false;
  private goodReceiptHasRowsKey: string = "invpay_goodReceiptHas";

  private sideModalSubject$: BehaviorSubject<
    IExternalAppData
  > = new BehaviorSubject(undefined);

  constructor(private storageManagerService: StorageManagerService,
  ) {
    this.initialize();
  }

  get financialDocument(): FinancialDocument {
    this._financialDocument = this.recoverSessionStorage(
      this.financialDocumentKey
    );
    this._financialDocument.createDateObj = this.getDateObject(
      this._financialDocument.createDate
    );
    this._financialDocument.dueDateObj = this.getDateObject(
      this._financialDocument.dueDate
    );
    this._financialDocument.disputeCompromiseDateObj = this.getDateObject(
      this._financialDocument.disputeCompromiseDate
    );
    this._financialDocument.disputeResolutionDateObj = this.getDateObject(
      this._financialDocument.disputeResolutionDate
    );
    return this._financialDocument;
  }
  set financialDocument(value: FinancialDocument) {
    this._financialDocument = this.recoverSessionStorage(
      this.financialDocumentKey
    );
    this._financialDocument = value;
    this.saveStoredData(this.financialDocumentKey, this._financialDocument);
  }

  get dispute(): Dispute {
    this._dispute = this.recoverSessionStorage(this.disputeKey);
    this._dispute.date = this.getDateObject(this._dispute.disputeDate);
    return this._dispute;
  }
  set dispute(value: Dispute) {
    this._dispute = this.recoverSessionStorage(this.disputeKey);
    this._dispute = value;
    this.saveStoredData(this.disputeKey, this._dispute);
  }

  get creditRequest(): CreditRequest {
    this._creditRequest = this.recoverSessionStorage(this.creditRequestKey);
    if (this._creditRequest !== undefined) {
      this._creditRequest.createDateObj = this.getDateObject(
        this._creditRequest.createDate
      );
    }
    return this._creditRequest;
  }
  set creditRequest(value: CreditRequest) {
    this._creditRequest = this.recoverSessionStorage(this.creditRequestKey);
    this._creditRequest = value;
    this.saveStoredData(this.creditRequestKey, this._creditRequest);
  }

  get clarificationsCategory(): string {
    this._clarificationsCategory = this.recoverSessionStorage(
      this.clarificationsCategoryKey
    );
    return this._clarificationsCategory;
  }
  set clarificationsCategory(value: string) {
    this._clarificationsCategory = this.recoverSessionStorage(
      this.clarificationsCategoryKey
    );
    this._clarificationsCategory = value;
    this.saveStoredData(
      this.clarificationsCategoryKey,
      this._clarificationsCategory
    );
  }

  get checkedFinancialDocuments(): FinancialDocument[] {
    this._checkedFinancialDocuments = this.recoverSessionStorage(
      this.checkedFinancialDocumentsKey
    );
    if (
      this._checkedFinancialDocuments === undefined ||
      this._checkedFinancialDocuments === null
    ) {
      this._checkedFinancialDocuments = [];
    }
    return this._checkedFinancialDocuments;
  }
  set checkedFinancialDocuments(value: FinancialDocument[]) {
    this._checkedFinancialDocuments = this.recoverSessionStorage(
      this.checkedFinancialDocumentsKey
    );
    this._checkedFinancialDocuments = value;
    this.saveStoredData(
      this.checkedFinancialDocumentsKey,
      this._checkedFinancialDocuments
    );
  }

  get dateRange(): CwcInputDateRange {
    this._dateRange = this.recoverSessionStorage(this.dateRangeKey);
    if (this._dateRange === undefined || this._dateRange === null) {
      this._dateRange = { from: undefined, to: undefined };
    }
    return this._dateRange;
  }
  set dateRange(value: CwcInputDateRange) {
    this._dateRange = this.recoverSessionStorage(this.dateRangeKey);
    this._dateRange = value;
    this.saveStoredData(this.dateRangeKey, this._dateRange);
  }

  get checkedGoodReceiptDocuments(): any[] {
    this._checkedGoodReceiptDocuments = this.recoverSessionStorage(
      this.checkedGoodReceiptDocumentsKey
    );
    if (
      this._checkedGoodReceiptDocuments === undefined ||
      this._checkedGoodReceiptDocuments === null
    ) {
      this._checkedGoodReceiptDocuments = [];
    }
    return this._checkedGoodReceiptDocuments;
  }

  set checkedGoodReceiptDocuments(value: any[]) {
    this._checkedGoodReceiptDocuments = this.recoverSessionStorage(
      this.checkedGoodReceiptDocumentsKey
    );
    this._checkedGoodReceiptDocuments = value;
    this.saveStoredData(
      this.checkedGoodReceiptDocumentsKey,
      this._checkedGoodReceiptDocuments
    );
    if (value.length > 0) {
      this.saveStoredData(this.goodReceiptHasRowsKey, true);
    } else {
      this.saveStoredData(this.goodReceiptHasRowsKey, false);
    }
  }

  get goodReceiptHasRows(): boolean {
    this._goodReceiptHasRows = this.recoverSessionStorage(
      this.goodReceiptHasRowsKey
    );
    if (
      this._goodReceiptHasRows === undefined ||
      this._goodReceiptHasRows === null
    ) {
      this._goodReceiptHasRows = false;
    }
    return this._goodReceiptHasRows;
  }

  set goodReceiptHasRows(value: boolean) {
    this._goodReceiptHasRows = this.recoverSessionStorage(
      this.goodReceiptHasRowsKey
    );
    this._goodReceiptHasRows = value;
    this.saveStoredData(this.goodReceiptHasRowsKey, this._goodReceiptHasRows);
  }

  get userInfo() {
    this._userInfo = this.storageManagerService.token_data || undefined;
    return this._userInfo;
  }

  get userProfile() {
    this._userProfile = this.storageManagerService.user_profile;
    return this._userProfile;
  }

  get documentReferences(): DocumentReference {
    this._documentReferences = this.recoverSessionStorage(
      this.documentReferencesKey
    );
    this._documentReferences.dateEndObj = this.getDateObject(
      this._documentReferences.dateEnd
    );
    this._documentReferences.dateStartObj = this.getDateObject(
      this._documentReferences.dateStart
    );
    this._documentReferences.referenceDateObj = this.getDateObject(
      this._documentReferences.referenceDate
    );
    this._documentReferences.uploadDateObj = this.getDateObject(
      this._documentReferences.uploadDate
    );
    return this._documentReferences;
  }
  set documentReferences(value: DocumentReference) {
    this._documentReferences = this.recoverSessionStorage(
      this.documentReferencesKey
    );
    this._documentReferences = value;
    this.saveStoredData(this.documentReferencesKey, this._documentReferences);
  }

  get checkedDocumentReferences(): DocumentReference[] {
    this._checkedDocumentReferences = this.recoverSessionStorage(
      this.checkedDocumentReferencesKey
    );
    if (
      this._checkedDocumentReferences === undefined ||
      this._checkedDocumentReferences === null
    ) {
      this._checkedDocumentReferences = [];
    }
    return this._checkedDocumentReferences;
  }
  set checkedDocumentReferences(value: DocumentReference[]) {
    this._checkedDocumentReferences = this.recoverSessionStorage(
      this.checkedDocumentReferencesKey
    );
    this._checkedDocumentReferences = value;
    this.saveStoredData(
      this.checkedDocumentReferencesKey,
      this._checkedDocumentReferences
    );
  }

  get formDataDocumentReferences(): any {
    return this._formDataDocumentReferences;
  }
  set formDataDocumentReferences(value: any) {
    this._formDataDocumentReferences = value;
  }

  get bulkExcelDocCenter(): boolean {
    const aux = sessionStorage.getItem(this.bulkExcelDocCenterKey);
    if (aux !== undefined && aux !== null) {
      this._bulkExcelDocCenter = JSON.parse(aux);
    } else {
      this._bulkExcelDocCenter = undefined;
    }
    return this._bulkExcelDocCenter;
  }
  set bulkExcelDocCenter(value: boolean) {
    if (value !== undefined && value !== null) {
      this._bulkExcelDocCenter = value;
      sessionStorage.setItem(
        this.bulkExcelDocCenterKey,
        JSON.stringify(this._bulkExcelDocCenter)
      );
    } else {
      this._bulkExcelDocCenter = undefined;
      sessionStorage.removeItem(this.bulkExcelDocCenterKey);
    }
  }
  // ========================================================================================
  // public methods
  // ========================================================================================

  public destroySessionStorages(): void {
    sessionStorage.removeItem(this.checkedFinancialDocumentsKey);
    sessionStorage.removeItem(this.financialDocumentKey);
    sessionStorage.removeItem(this.bulkExcelDocCenterKey);
    sessionStorage.removeItem(this.checkedDocumentReferencesKey);
  }

  public addCheckedFinancialDocumentsArray(
    $documents: FinancialDocument[]
  ): void {
    if ($documents != undefined) {
      this._checkedFinancialDocuments = $documents;
      this.checkedFinancialDocuments = this._checkedFinancialDocuments;
    }
  }

  public addCheckedFinancialDocument($document: FinancialDocument): void {
    if ($document != undefined) {
      const $foundDocument = this._checkedFinancialDocuments.find(
        ($checkedDocument) => {
          return $checkedDocument.documentId === $document.documentId;
        }
      );
      if ($foundDocument == undefined) {
        this._checkedFinancialDocuments.push($document);
        this.checkedFinancialDocuments = this._checkedFinancialDocuments;
      }
      // this.updateSessionStorage( this.checkedFinancialDocumentsKey, this._checkedFinancialDocuments );
    }
  }

  public removeCheckedFinancialDocument($document: FinancialDocument): void {
    if ($document != undefined) {
      const updatedDocuments = this._checkedFinancialDocuments.filter(
        (document) => document.documentId !== $document.documentId
      );

      // Actualiza las propiedades con la nueva lista
      this._checkedFinancialDocuments = updatedDocuments;
      this.checkedFinancialDocuments = updatedDocuments;

      //this.updateSessionStorage(this.checkedFinancialDocumentsKey, updatedDocuments);
    }
  }

  //private updateSessionStorage(key: string, value: any): void {
  //  const jsonValue = JSON.stringify(value);
  //  sessionStorage.setItem(key, jsonValue);
  //}

  public addCheckedDocumentReferences($document: DocumentReference): void {
    if ($document !== undefined && $document !== null) {
      this._checkedDocumentReferences.push($document);
      this.checkedDocumentReferences = this._checkedDocumentReferences;
    }
  }

  public removeCheckedDocumentReferences($document: DocumentReference): void {
    if ($document !== undefined && $document !== null) {
      this._checkedDocumentReferences.forEach(($checkedDocument, $index) => {
        if ($checkedDocument.blobDocumentId === $document.blobDocumentId) {
          this._checkedDocumentReferences.splice($index, 1);
          this.checkedDocumentReferences = this._checkedDocumentReferences;
          // this.updateSessionStorage( this.checkedFinancialDocumentsKey, this._checkedFinancialDocuments );
        }
      });
    }
  }

  public cleanCheckedDocumentReferences(): void {
    this._checkedDocumentReferences = [];
    this.checkedDocumentReferences = this._checkedDocumentReferences;
  }

  public cleanCheckedGoodReceipotDocuments(): void {
    this._checkedGoodReceiptDocuments = [];
    this.checkedGoodReceiptDocuments = this._checkedGoodReceiptDocuments;
  }

  public addCheckedGoodReceiptDocumentsByArray($documentsArray: any): void {
    if ($documentsArray !== undefined && $documentsArray !== null) {
      $documentsArray.forEach(elementArray => {
        elementArray.forEach(element => {
          if (
            this._checkedGoodReceiptDocuments.findIndex(
              (x) => x.blobDocumentId === element.blobDocumentId && x.goodReceiptId === element.goodReceiptId
            ) == -1
          ) {
            this._checkedGoodReceiptDocuments.push(element);
            this.checkedGoodReceiptDocuments = this._checkedGoodReceiptDocuments;
          }
        });
      });
    }
  }

  public addCheckedGoodReceiptDocuments($document: any): void {
    if ($document !== undefined && $document !== null) {
      if (
        this._checkedGoodReceiptDocuments.findIndex(
          (x) => x.blobDocumentId === $document.blobDocumentId && x.goodReceiptId === $document.goodReceiptId
        ) == -1
      ) {
        this._checkedGoodReceiptDocuments.push($document);
        this.checkedGoodReceiptDocuments = this._checkedGoodReceiptDocuments;
      }
    }
  }

  public removeCheckedGoodReceiptDocumentsByArray($documentsArray: any): void {
    if ($documentsArray !== undefined && $documentsArray !== null) {
      $documentsArray.forEach(elementArray => {
        elementArray.forEach(element => {
          let index = this._checkedGoodReceiptDocuments.findIndex(
            (x) => x.blobDocumentId == element.blobDocumentId && x.goodReceiptId === element.goodReceiptId
          );
          if (index != -1) {
            this._checkedGoodReceiptDocuments.splice(index, 1);
            this.checkedGoodReceiptDocuments = this._checkedGoodReceiptDocuments;
          }
        });
      });
    }
  }

  public removeCheckedGoodReceiptDocuments($document: any): void {
    if ($document !== undefined && $document !== null) {
      let index = this._checkedGoodReceiptDocuments.findIndex(
        (x) => x.blobDocumentId == $document.blobDocumentId && x.goodReceiptId === $document.goodReceiptId
      );
      if (index != -1) {
        this._checkedGoodReceiptDocuments.splice(index, 1);
        this.checkedGoodReceiptDocuments = this._checkedGoodReceiptDocuments;
      }
    }
  }

  public resetGoodReceipts(): void {
    this.checkedGoodReceiptDocuments = [];
  }

  // public methods
  // ========================================================================================

  private initialize(): void {
  }

  private recoverSessionStorage($itemKey: string): any {
    const aux = sessionStorage.getItem($itemKey);
    if (
      aux !== undefined &&
      aux !== null &&
      aux !== "undefined" &&
      aux !== "null"
    ) {
      return JSON.parse(aux);
    } else {
      return undefined;
    }
  }

  private saveStoredData($itemKey: string, $item: any): void {
    sessionStorage.setItem($itemKey, JSON.stringify($item));
  }

  /**
   * @description Transforms a date string to a javascript date object.
   * @param string $date - The string of a date.
   */
  private getDateObject($date: string): Date {
    try {
      const $bit = $date.split("T");
      const date: string = $bit[0];
      const time: string = $bit[1];
      return new Date(date.replace(/\-/g, "/") + " " + time);
    } catch ($exception) {
      console.error("Could not transform string to date", $date);
      return undefined;
    }
  }

  public getSideModalSubject(): BehaviorSubject<IExternalAppData> {
    return this.sideModalSubject$;
  }
}
